import script from "./CreateUpdateContractTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateUpdateContractTypeModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__